import { isGiggleNull } from "./api";

/** "Sat, Oct 31" (or "Sat, Oct 31, 2026" with withYear). */
export const formatDay = (value, withYear = false) => {
  const d = new Date(value);
  if (isNaN(d.getTime())) return "Date TBA";
  return d.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric", ...(withYear ? { year: "numeric" } : {}) });
};

/** Day range: "Sat, Oct 31" or "Sat, Oct 31 - Sun, Nov 1". */
export const formatDayRange = (start, end) => {
  const s = new Date(start);
  const e = new Date(end);
  if (isNaN(s.getTime()) || isNaN(e.getTime())) return "Date TBA";
  return s.toDateString() === e.toDateString() ? formatDay(start) : `${formatDay(start)} - ${formatDay(end)}`;
};

/** "5:30 PM onwards". Event times are shown as stored, not shifted to the viewer's timezone. */
export const formatStartTime = (value) => {
  const time = value?.split("T")[1]?.substring(0, 5);
  if (!time) return "Time TBA";
  const [h, m] = time.split(":").map(Number);
  return `${h % 12 || 12}:${String(m).padStart(2, "0")} ${h >= 12 ? "PM" : "AM"} onwards`;
};

export const formatTimeAgo = (value) => {
  const diff = Date.now() - new Date(value).getTime();
  const min = Math.floor(diff / 60000);
  const hr = Math.floor(min / 60);
  const day = Math.floor(hr / 24);
  if (day > 0) return `${day}d ago`;
  if (hr > 0) return `${hr}h ago`;
  if (min > 0) return `${min}m ago`;
  return "Just now";
};

/** Downloads an .ics file so the event can be added to any calendar app. */
export function downloadCalendarFile(event) {
  const stamp = (v) => new Date(v).toISOString().replace(/[-:]/g, "").replace(/\.\d{3}/, "");
  const escape = (v) => (v || "").replace(/\\/g, "\\\\").replace(/\n/g, "\\n").replace(/[,;]/g, (m) => `\\${m}`);
  const location = [event.event_venue, isGiggleNull(event.event_address) ? "" : event.event_address].filter(Boolean).join(", ");
  const ics = [
    "BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//Blox//Events//EN", "BEGIN:VEVENT",
    `UID:blox-event-${event.id}@bloxsocial.co`,
    `DTSTAMP:${stamp(new Date().toISOString())}`,
    `DTSTART:${stamp(event.event_start_date)}`,
    `DTEND:${stamp(event.event_end_date)}`,
    `SUMMARY:${escape(event.event_name)}`,
    `LOCATION:${escape(location)}`,
    `DESCRIPTION:${escape(`${(event.event_description || "").slice(0, 300)}\n\n${event.event_url || ""}`)}`,
    "END:VEVENT", "END:VCALENDAR",
  ].join("\r\n");
  const url = URL.createObjectURL(new Blob([ics], { type: "text/calendar;charset=utf-8" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = `${(event.event_name || "event").replace(/[^\w-]+/g, "-").replace(/^-|-$/g, "") || "event"}.ics`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
